import { render, staticRenderFns } from "./ProductAnalytics.vue?vue&type=template&id=495771ae&scoped=true&"
import script from "./ProductAnalytics.vue?vue&type=script&lang=js&"
export * from "./ProductAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495771ae",
  null
  
)

export default component.exports